export const companiesTableHead = [
    {
      id: 'id',
      label: 'ID firmy',
    },
    {
      id: 'name',
      label: 'Nazwa',
    },
    {
      id: 'email',
      label: 'Email',
    },
    {
      id: 'openComplainsAmount',
      label: 'Liczba otwartych skarg',
    },
    {
      id: 'closeComplainsAmount',
      label: 'Liczba zamkniętych skarg',
    },
    {
        id: 'answerRating',
        label: 'Ratio',
    },
    {
      id: 'undeliveredComplains',
      label: 'Niedostarczone skargi',
    },
  ];

export const companiesSummaryTableHead = [
    {
        id: 'id',
        label: 'ID firmy',
    },
    {
        id: 'name',
        label: 'Nazwa',
    },
    {
        id: 'email',
        label: 'Email',
    },
    {
        id: 'openComplainsAmount',
        label: 'Liczba otwartych skarg',
    },
    {
        id: 'closeComplainsAmount',
        label: 'Liczba zamkniętych skarg',
    },
    {
        id: 'mostIn30Days',
        label: 'Ostatnie 30 dni',
    },
    {
        id: 'mostIn365Days',
        label: 'Ostatnie 365 dni',
    },
    {
        id: 'undeliveredComplains',
        label: 'Niedostarczone skargi',
    },
];